
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftLeft50 as ObiThreewayAcuatorPistonInleftLeft50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-left-50.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftLeft50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-left-50',
   elementClass: ObiThreewayAcuatorPistonInleftLeft50Element,
   events: {
     
   }
  });
 
 